import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  Router,
  NavigationStart,
  ActivatedRoute,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  NavigationCancel,
  NavigationEnd
} from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

// Sensible portal-wide fallbacks used whenever a route does not define its own
// description/keywords, so every page still ships baseline metadata.
const DEFAULT_META_DESCRIPTION =
  'The National Apprenticeship Promotion Scheme (NAPS) portal by the Government of India connects apprentices and establishments, enabling registration, training, stipend and certification under the Apprenticeship Act.';
const DEFAULT_META_KEYWORDS =
  'apprenticeship, NAPS, National Apprenticeship Promotion Scheme, apprentice, establishment, skill development, NSDC, apprenticeship training, Government of India';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private activatedRoute: ActivatedRoute
) { }

updateMetaInfo(content, author, category) {
    this.meta.updateTag({ name: 'description', content: content });
    this.meta.updateTag({ name: 'author', content: author });
    this.meta.updateTag({ name: 'keywords', content: category });
}

updateTitle(title?: string) {
    if (!title) {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) { route = route.firstChild; }
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data)).subscribe((event) => {
                    this.titleService.setTitle(event['title'] + ' | Apprenticeship Training Portal');
                    this.updateMetaTags(event);
                });
    } else {
        this.titleService.setTitle(title + ' | Apprenticeship Training Portal');
    }
}

private updateMetaTags(routeData: { [key: string]: any }): void {
    const description = routeData['description'];
    const keywords = routeData['keywords'];

    if (description) {
        this.meta.updateTag({ name: 'description', content: description });
    } else {
        this.meta.updateTag({ name: 'description', content: DEFAULT_META_DESCRIPTION });
    }

    if (keywords) {
        this.meta.updateTag({ name: 'keywords', content: keywords });
    } else {
        this.meta.updateTag({ name: 'keywords', content: DEFAULT_META_KEYWORDS });
    }
}
}
